import { render, staticRenderFns } from "./clinicalPreferences.vue?vue&type=template&id=082f6340&scoped=true"
import script from "./clinicalPreferences.vue?vue&type=script&lang=js"
export * from "./clinicalPreferences.vue?vue&type=script&lang=js"
import style0 from "./clinicalPreferences.vue?vue&type=style&index=0&id=082f6340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f6340",
  null
  
)

export default component.exports